(() => {
  if (window.siteIntegrationsLoaded) return;
  window.siteIntegrationsLoaded = true;

  const clarityProjectId = 'xjuzrrw7w8';

  function isThemeEditor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function ensureClarityQueue() {
    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
  }

  function getConsentState() {
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy) {
      return {
        analytics_Storage: 'denied',
        ad_Storage: 'denied',
      };
    }

    return {
      analytics_Storage:
        typeof customerPrivacy.analyticsProcessingAllowed === 'function' &&
        customerPrivacy.analyticsProcessingAllowed()
          ? 'granted'
          : 'denied',
      ad_Storage:
        typeof customerPrivacy.marketingAllowed === 'function' &&
        customerPrivacy.marketingAllowed()
          ? 'granted'
          : 'denied',
    };
  }

  function syncClarityConsent() {
    if (isThemeEditor()) return;

    ensureClarityQueue();
    window.clarity('consentv2', getConsentState());
  }

  function loadClarity() {
    if (isThemeEditor() || document.querySelector('script[data-site-clarity]')) return;

    ensureClarityQueue();
    syncClarityConsent();

    const script = document.createElement('script');
    script.async = true;
    script.dataset.siteClarity = 'true';
    script.src = `https://www.clarity.ms/tag/${clarityProjectId}`;
    document.head.appendChild(script);
  }

  function scheduleClarity() {
    const run = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadClarity, { timeout: 2500 });
      } else {
        window.setTimeout(loadClarity, 1);
      }
    };

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  document.addEventListener('visitorConsentCollected', syncClarityConsent);
  document.addEventListener('trackingConsentAccepted', syncClarityConsent);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', syncClarityConsent);

  scheduleClarity();
})();
